import React, { FC } from 'react';
import { Image } from 'react-native';
import { TWCText } from '@components';

import { assets } from '@assets';
import { dailyDaypartForecastTestIDs } from '@constants';

import { styles } from './styles';

type DaypartDayProps = {
  daypartName: string;
  error?: unknown;
  sunriseTime: string;
  sunsetTime: string;
  t: (val: string) => string;
};

export const DaypartDay: FC<DaypartDayProps> = ({ error, daypartName, sunriseTime, sunsetTime, t }) => {
  const testIDs = dailyDaypartForecastTestIDs;

  return (
    <>
      <TWCText testID={testIDs.dayName} variant={'regularText'}>
        {error ? '—' : daypartName}
      </TWCText>
      <Image source={assets.sunrise} style={[styles.sunIcon, styles.sunrise]} />
      <TWCText style={styles.sunriseLabel} testID={testIDs.sunriseLabel} variant={'regularText24Transparent'}>
        {t('sunriseLabel')}
      </TWCText>
      <TWCText style={styles.timeText} testID={testIDs.sunriseValue} variant={'regularText30'}>
        {sunriseTime}
      </TWCText>
      <Image source={assets.sunset} style={[styles.sunIcon, styles.sunset]} />
      <TWCText style={styles.sunsetLabel} testID={testIDs.sunsetLabel} variant={'regularText24Transparent'}>
        {t('sunsetLabel')}
      </TWCText>
      <TWCText style={styles.timeText} testID={testIDs.sunsetValue} variant={'regularText30'}>
        {sunsetTime}
      </TWCText>
    </>
  );
};
